import { Fragment, ReactNode } from 'react';

const isNotAReactComponent = (content: ReactNode) =>
    content &&
    ((typeof content === 'object' && 'type' in content && content.type === Fragment) || !(typeof content === 'object'));

export default isNotAReactComponent;
